import React, { useMemo, useState } from 'react';
import { Form, InputGroup } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes, faBuilding } from "@fortawesome/free-solid-svg-icons";

const CompanyCheckboxPicker = ({ companies = [], selectedIds = [], onChange, error, disabled = false }) => {
  const [search, setSearch] = useState('');

  const selectedCompanies = companies.filter((company) => selectedIds.includes(String(company.id)));
  const filteredCompanies = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return companies;
    return companies.filter((company) => company.name.toLowerCase().includes(term));
  }, [companies, search]);

  const toggleCompany = (companyId, checked) => {
    if (disabled) return;
    const normalizedId = String(companyId);
    const nextIds = checked
      ? [...selectedIds, normalizedId]
      : selectedIds.filter((id) => id !== normalizedId);

    onChange([...new Set(nextIds)]);
  };

  return (
    <Form.Group controlId="company_ids" className="company-picker">
      <div className="company-picker__header">
        <Form.Label className="mb-0">Companies <span className="text-danger">*</span></Form.Label>
        <span className="text-muted small">{selectedCompanies.length} selected</span>
      </div>

      {selectedCompanies.length > 0 && (
        <div className="company-picker__selections">
          {selectedCompanies.map((company) => (
            <span key={company.id} className="company-picker__selection">
              <span className="company-picker__selection-name">{company.name}</span>
              <button
                type="button"
                className="company-picker__remove"
                disabled={disabled}
                aria-label={`Remove ${company.name}`}
                onClick={() => toggleCompany(company.id, false)}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </span>
          ))}
        </div>
      )}

      {companies.length > 5 && (
        <InputGroup className="mb-2" size="sm">
          <InputGroup.Text><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
          <Form.Control
            type="text"
            placeholder="Search companies..."
            aria-label="Search companies"
            disabled={disabled}
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
        </InputGroup>
      )}

      <div
        className={`company-picker__options ${error ? 'company-picker__options--invalid' : ''}`}
        role="group"
        aria-label="Available companies"
      >
        {filteredCompanies.length === 0 ? (
          <div className="company-picker__empty text-muted text-center py-3">
            <FontAwesomeIcon icon={faBuilding} className="mb-2 d-block mx-auto" size="lg" />
            No companies found.
          </div>
        ) : (
          filteredCompanies.map((company) => {
            const companyId = String(company.id);
            const checked = selectedIds.includes(companyId);
            return (
              <div
                key={company.id}
                className={`company-picker__option ${checked ? 'company-picker__option--selected' : ''}`}
              >
                <Form.Check
                  type="checkbox"
                  id={`company-${company.id}`}
                  label={company.name}
                  checked={checked}
                  disabled={disabled}
                  onChange={(event) => toggleCompany(company.id, event.target.checked)}
                  className="company-picker__check"
                />
              </div>
            );
          })
        )}
      </div>
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </Form.Group>
  );
};

export default CompanyCheckboxPicker;
